var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"atom-square",on:{"click":_vm.handleClick}},[(_vm.icon)?_c('span',{staticClass:"icon material-icons material-icons-outlined"},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }